import { render, staticRenderFns } from "./unsatisfactory-receiving-list.vue?vue&type=template&id=c6cc06ec&scoped=true"
import script from "./unsatisfactory-receiving-list.vue?vue&type=script&lang=js"
export * from "./unsatisfactory-receiving-list.vue?vue&type=script&lang=js"
import style0 from "./unsatisfactory-receiving-list.vue?vue&type=style&index=0&id=c6cc06ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6cc06ec",
  null
  
)

export default component.exports